import script from "./EditTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTemplate.vue?vue&type=script&setup=true&lang=js"

import "./EditTemplate.vue?vue&type=style&index=0&id=33f929b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f929b0"]])

export default __exports__